const OG = ({property, content}) => <meta property={`og:${property}`} content={content}/>

export default OG;